import { memo, Activity } from "react";
import { Pagination } from "@ir/ui";
import PageFooter from "@/presentation/ui/layouts/page/PageFooter";

interface ApprovalsPaginationProps {
  hasPagination: boolean;
  totalCount: number;
  pageLimit: number;
  currentPage: number;
  isLoading: boolean;
  onPageChange: (page: number) => void;
}

const ApprovalsPagination = memo(({
  hasPagination,
  totalCount,
  pageLimit,
  currentPage,
  isLoading,
  onPageChange,
}: ApprovalsPaginationProps) => {
  return (
    <Activity name="approvals-pagination" mode={hasPagination ? "visible" : "hidden"}>
      <PageFooter className="approvals-page-footer">
        <Pagination
          totalItems={totalCount}
          itemsPerPage={pageLimit}
          currentPage={currentPage}
          onPageChange={onPageChange}
          isDisabled={isLoading}
        />
      </PageFooter>
    </Activity>
  );
});

ApprovalsPagination.displayName = "ApprovalsPagination";

export { ApprovalsPagination };
